import Media from 'modules/product_updates/components/ListSection/_Item/_Media'

interface Props {
  alt: string
  src: string
}

export const Video = ({ alt, src }: Props) => {
  return (
    <Media
      video={{
        url: src,
        alt,
        video: true,
      }}
      thumbnail={{
        src: undefined,
      }}
      title={alt}
      autoPlay
    />
  )
}
